/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const getUpdateLogOutput = `query UpdateLogOutput($customer_id: String!, $machine_id: String!, $event_id: String!) {
    updateLogOutputWithPartials(customer_id: $customer_id, machine_id: $machine_id, event_id: $event_id) {
      output
    }
  }
  `;
